import { render, staticRenderFns } from "./DropdownAlbums.vue?vue&type=template&id=4884a3d2&"
import script from "./DropdownAlbums.vue?vue&type=script&lang=js&"
export * from "./DropdownAlbums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports